import styled from 'styled-components';
import { tokens } from 'styles/tokens';

export const Hyperlink = styled.a`
    color: ${tokens.text.link};
    text-decoration: none;
`;
